<template>
    <div>
        <v-expansion-panel>
            <v-expansion-panel-content :class="headerClass">
                <div slot="header"><v-toolbar-title>Summary</v-toolbar-title></div>
                <v-card>
                    <v-card-text :class="subheaderClass">
                        <template v-for="(at, index) in AverageTotal">
                            <v-toolbar :dense="true" :class="toolbarClass">
                                {{index}}
                                <v-spacer></v-spacer>
                                {{at}}
                            </v-toolbar>
                        </template>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>

export default {
    props: [ 'averagetotal', 'headerClass', 'subheaderClass', 'toolbarClass' ],
    computed: {
        AverageTotal: function () {
            return this.$store.getters.getAverageTotal;
        }
    }
};
</script>

<style>
    li.header > div.expansion-panel__header {
        height: 64px;
    }

    .header > div.expansion-panel__header {
        padding: 0px;
    }
</style>



// WEBPACK FOOTER //
// summarySection.vue?75212b9d